import React, { useContext, useMemo } from 'react';
import App from './components/App';
import locationContext from './contexts/location';
import withLocation from './hocs/withLocation';
import { parseQuery } from './tools/DOMTools';

const Location = withLocation(() => {
  const { location } = useContext(locationContext);

  const params = useMemo(() => ({
    data: location,
    queryString: window.location.search || '',
    query: parseQuery(window.location.search || ''),
    state: process.env.REACT_APP_MODE || '1',
  }), [location]);

  return (
    <App params={params} />
  );
});

export default Location;
